/**
 * Transloadit constants for the fileUpload part.
 */

const exported = {
  transloaditKey: '05912e90e83346abb96c261bf458b615',
  peerReviewTransloaditTemplateId: '5daef0a0169d11e49fb59d7fc80efd48',
};

export default exported;

export const { transloaditKey, peerReviewTransloaditTemplateId } = exported;
